import { LockClosedIcon } from '@heroicons/react/20/solid';
import MainLogo from '../../assets/images/dl-logo.png';
import {
    FullRow,
    FormInputField
} from '../../components';
import useForgotPassword from './hooks/useForgotPassword';

const ForgotPassword = ({ performForgotPassword }) => {
    const {
        register,
        onSubmit,
        errors,
        loginError,
        successMessage,
        isSubmitting,
        email,
        setLoginError
    } = useForgotPassword(performForgotPassword);

    return (
        <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="w-full max-w-md space-y-8">
                <div>
                    <img
                        className="mx-auto h-24 w-auto"
                        src={MainLogo}
                        alt="DocLinkLogo"
                    />
                    <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-blue-900">
                        Recuperación de contraseña
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        Escribe tu correo para enviarte un enlace de recuperación.
                    </p>
                </div>
                <form className="mt-8 space-y-6" onSubmit={onSubmit}>
                    <input type="hidden" name="remember" defaultValue="true" />
                    <div className="-space-y-px flex flex-col gap-4">
                        <FullRow>
                            <FormInputField
                                identifier="email"
                                label="Correo electrónico"
                                type="string"
                                errorMessage={errors.email ? 'Este campo es requerido' : loginError}
                                registration={{
                                    ...register('email', {
                                        required: true,
                                        onChange: () => {
                                            if (loginError) setLoginError('');
                                        }
                                    })
                                }}
                            />
                        </FullRow>
                    </div>

                    {successMessage && (
                        <div className="text-green-600 text-center font-medium mt-4">
                            {successMessage}
                        </div>
                    )}

                    <div>
                        <button
                            type="submit"
                            disabled={!email || email.trim() === '' || isSubmitting}
                            className={`group relative flex w-full justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white 
                                ${!email || isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-700'} 
                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                        >
                            {isSubmitting ? 'Enviando...' : 'Solicitar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
